// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    box-sizing: border-box;
  }

html, body {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBackground"]};
    font-size: 14px;
    height: 100%;
    margin: 0;
    padding: 0;
    text-rendering: optimizeLegibility;
  }

body *::-webkit-scrollbar {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]};
      width: 10px;
    }

body *::-webkit-scrollbar-track {
      -webkit-box-shadow: none;
    }

body *::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.4);
      outline: none;
    }

i {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

*, *::before, *::after {
    box-sizing: inherit;
  }

a {
    box-shadow: 0 1px 0 rgba(55, 110, 161, 0.2);
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    -webkit-text-decoration: none;
    text-decoration: none;
    transition: all 0.2s;
  }

a:hover {
      box-shadow: 0 1px 0 rgba(55, 110, 161, 1);
    }

a:focus {
      outline: none;
    }

*:focus {
    outline: none;
  }

button {
    cursor: pointer;
  }

button:focus {
      outline: none;
    }

img {
    max-width: 100%;
  }

.half {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(99.9% * 1/2 - (20px - 20px * 1/2));
    max-width: calc(99.9% * 1/2 - (20px - 20px * 1/2));
    width: calc(99.9% * 1/2 - (20px - 20px * 1/2));
  }

.half:nth-child(1n) {
    margin-right: 20px;
    margin-left: 0;
  }

.half:last-child {
    margin-right: 0;
  }

@media only screen and (max-width: 768px) {

.half {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(99.9% * 1 - (20px - 20px * 1));
      max-width: calc(99.9% * 1 - (20px - 20px * 1));
      width: calc(99.9% * 1 - (20px - 20px * 1));
  }

.half:nth-child(1n) {
      margin-right: 20px;
      margin-left: 0;
  }

.half:last-child {
      margin-right: 0;
  }
    }

.third {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(99.9% * 1/3 - (20px - 20px * 1/3));
    max-width: calc(99.9% * 1/3 - (20px - 20px * 1/3));
    width: calc(99.9% * 1/3 - (20px - 20px * 1/3));
  }

.third:nth-child(1n) {
    margin-right: 20px;
    margin-left: 0;
  }

.third:last-child {
    margin-right: 0;
  }

.quarter {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(99.9% * 1/4 - (20px - 20px * 1/4));
    max-width: calc(99.9% * 1/4 - (20px - 20px * 1/4));
    width: calc(99.9% * 1/4 - (20px - 20px * 1/4));
  }

.quarter:nth-child(1n) {
    margin-right: 20px;
    margin-left: 0;
  }

.quarter:last-child {
    margin-right: 0;
  }

.checkbox label {
      display: inline-block;
      line-height: 30px;
      margin: 0;
    }

.checkbox > div > div {
      float: left;
    }

.checkbox input {
      height: 30px;
      width: 30px;
    }

.fileLabel {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
    font-size: 12px;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

.column {
    display: flex;
    flex-flow: column nowrap;
  }

.row {
    display: flex;
    flex-flow: row wrap;
  }

.clearfix::after {
    clear: both;
    content: '';
    display: table;
  }

.titleWrapper {
    margin-bottom: 20px;
    width: 100%;
  }

.title {
    flex: 1;
    margin: 0;
  }

.subtitle {
    margin: 0;
  }

.clear {
    clear: both;
  }

.content-container {
    display: flex;
    flex-flow: row wrap;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    padding-top: 20px;
  }

.section {
    background: white;
    border-radius: 3px;
    margin-bottom: 20px;
    padding: 20px;
    width: 100%;
  }

.sectionSmall {
    background: white;
    border-radius: 3px;
    margin-bottom: 1px;
    padding: 20px;
    width: 100%;
  }

.sectionLarge {
    background: white;
    border-radius: 3px;
    margin-bottom: 40px;
    padding: 20px;
    width: 100%;
  }

.sectionTitle {
    background: white;
    border-radius: 3px;
    margin-bottom: 1px;
    padding: 10px 20px;
    width: 100%;
  }

.sectionMinus {
    margin-bottom: -19px;
  }

.filterButton {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
    border: none;
    border-radius: 3px;
    box-shadow: none;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
    cursor: pointer;
    display: inline-block;
    font-size: 13px;
    font-weight: 700;
    height: 36px;
    line-height: 36px;
    margin-left: 20px;
    padding: 0 1.5em;
    -webkit-text-decoration: none;
    text-decoration: none;
    text-shadow: none;
    transition: all 0.25s;
    width: auto;
  }

.filterButton:hover {
      box-shadow: none;
      opacity: 0.9;
    }

.filterButton:active {
      background: #e0e0e0;
    }

.filterButton:first-child {
      margin-left: 0;
    }

.filterButton.active {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
      color: white;
    }

.oneThird {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(99.9% * 1/3 - (20px - 20px * 1/3));
    max-width: calc(99.9% * 1/3 - (20px - 20px * 1/3));
    width: calc(99.9% * 1/3 - (20px - 20px * 1/3));
  }

.oneThird:nth-child(1n) {
    margin-right: 20px;
    margin-left: 0;
  }

.oneThird:last-child {
    margin-right: 0;
  }

.twoThird {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(99.9% * 2/3 - (20px - 20px * 2/3));
    max-width: calc(99.9% * 2/3 - (20px - 20px * 2/3));
    width: calc(99.9% * 2/3 - (20px - 20px * 2/3));
  }

.twoThird:nth-child(1n) {
    margin-right: 20px;
    margin-left: 0;
  }

.twoThird:last-child {
    margin-right: 0;
  }

.capitalize {
    display: inline-block;
  }

.capitalize::first-letter {
      text-transform: capitalize;
    }

.mono {
    font-family: MaisonMono, monospace;
  }

.hide {
    display: none;
  }

.label {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
    font-size: 12px;
  }

.phoneLabel {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
    display: inline-block;
    font-size: 12px;
    width: 60px;
  }

.marginBottom {
    margin-bottom: 20px;
  }

.bold {
    font-weight: bold;
  }

.light {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  }

.normal {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    font-weight: normal;
  }

.CalendarDay__default:hover {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]};
    border: 1px solid #e4e7e7;
    color: inherit;
  }

.CalendarDay__selected_span:active, .CalendarDay__selected_span:hover {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]};
    border: 1px solid #e4e7e7;
    color: black;
  }

.CalendarDay__selected_span {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
    border: 1px solid white;
    color: black;
  }

.CalendarDay__selected, .CalendarDay__selected:active, .CalendarDay__selected:hover {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    border: 1px solid white;
    color: white;
  }

.CalendarDay__hovered_span, .CalendarDay__hovered_span:hover {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
    border: 1px solid white;
  }

.DateRangePickerInput_calendarIcon_svg {
    fill: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  }

.DateInput_input__small {
    padding-bottom: 0;
  }

/* react-collapse animation */

.ReactCollapse--collapse {
    transition: height 500ms;
  }

/* react-simple-dropdown library style overrides */
.dropdown__trigger, .dropdown__trigger:hover {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    box-shadow: none;
    -webkit-text-decoration: none;
    text-decoration: none;
  }
.dropTriggerBackground {
    display: block;
    width: 0;
    height: 0;
    margin: auto;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity linear 250ms;
  }
.dropdown--active {
    display: flex;
  }
.dropdown--active .dropTriggerBackground {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
.dropdown--active .dropdown__content {
      display: flex;
      transform: translateX(0) translateY(0);
      opacity: 1;
    }
`, "",{"version":3,"sources":["webpack://./universal/styles/core.css"],"names":[],"mappings":"AASE;IACE,sBAAsB;EACxB;;AAEA;IAEE,8DAA8B;IAC9B,eAAe;IACf,YAAY;IACZ,SAAS;IACT,UAAU;IACV,kCAAkC;EACpC;;AAGE;MACE,wDAAuB;MACvB,WAAW;IACb;;AAEA;MACE,wBAAwB;IAC1B;;AAEA;MACE,oCAAoC;MACpC,aAAa;IACf;;AAGF;IACE,kCAAkC;IAClC,mCAAmC;EACrC;;AAEA;IAGE,mBAAmB;EACrB;;AAEA;IACE,2CAA2C;IAC3C,mDAAa;IACb,6BAAqB;IAArB,qBAAqB;IACrB,oBAAoB;EAStB;;AAPE;MACE,yCAAyC;IAC3C;;AAEA;MACE,aAAa;IACf;;AAGF;IACE,aAAa;EACf;;AAEA;IACE,eAAe;EAKjB;;AAHE;MACE,aAAa;IACf;;AAGF;IACE,eAAe;EACjB;;AAEA;IACE,YAAgB;IAAhB,cAAgB;IAAhB,mDAAgB;IAAhB,kDAAgB;IAAhB,8CAAgB;EAKlB;;AANA;IACE,kBAAgB;IAAhB,cAAgB;EAKlB;;AANA;IACE,eAAgB;EAKlB;;AAHE;;AAHF;MAII,YAAc;MAAd,cAAc;MAAd,+CAAc;MAAd,8CAAc;MAAd,0CAAc;EAElB;;AANA;MAII,kBAAc;MAAd,cAAc;EAElB;;AANA;MAII,eAAc;EAElB;IADE;;AAGF;IACE,YAAgB;IAAhB,cAAgB;IAAhB,mDAAgB;IAAhB,kDAAgB;IAAhB,8CAAgB;EAClB;;AAFA;IACE,kBAAgB;IAAhB,cAAgB;EAClB;;AAFA;IACE,eAAgB;EAClB;;AAEA;IACE,YAAgB;IAAhB,cAAgB;IAAhB,mDAAgB;IAAhB,kDAAgB;IAAhB,8CAAgB;EAClB;;AAFA;IACE,kBAAgB;IAAhB,cAAgB;EAClB;;AAFA;IACE,eAAgB;EAClB;;AAGE;MACE,qBAAqB;MACrB,iBAAiB;MACjB,SAAS;IACX;;AAEA;MACE,WAAW;IACb;;AAEA;MACE,YAAY;MACZ,WAAW;IACb;;AAGF;IACE,mDAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;AAEA;IACE,aAA2B;IAA3B,wBAA2B;EAC7B;;AAEA;IACE,aAAwB;IAAxB,mBAAwB;EAC1B;;AAEA;IACE,WAAW;IACX,WAAW;IACX,cAAc;EAChB;;AAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;AAEA;IACE,OAAO;IACP,SAAS;EACX;;AAEA;IACE,SAAS;EACX;;AAEA;IACE,WAAW;EACb;;AAEA;IACE,aAAwB;IAAxB,mBAAwB;IAAxB,iBAAwB;IAAxB,iBAAwB;IAAxB,kBAAwB;IAAxB,kBAAwB;IAAxB,mBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;EACnB;;AAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,WAAW;EACb;;AAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,WAAW;EACb;;AAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,WAAW;EACb;;AAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;AAEA;IACE,oBAAoB;EACtB;;AAEA;IACE,wDAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mDAAc;IACd,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,6BAAqB;IAArB,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;EAmBb;;AAjBE;MACE,gBAAgB;MAChB,YAAY;IACd;;AAEA;MACE,mBAAmB;IACrB;;AAEA;MACE,cAAc;IAChB;;AAEA;MACE,wDAAmB;MACnB,YAAY;IACd;;AAGF;IACE,YAAgB;IAAhB,cAAgB;IAAhB,mDAAgB;IAAhB,kDAAgB;IAAhB,8CAAgB;EAClB;;AAFA;IACE,kBAAgB;IAAhB,cAAgB;EAClB;;AAFA;IACE,eAAgB;EAClB;;AAEA;IACE,YAAgB;IAAhB,cAAgB;IAAhB,mDAAgB;IAAhB,kDAAgB;IAAhB,8CAAgB;EAClB;;AAFA;IACE,kBAAgB;IAAhB,cAAgB;EAClB;;AAFA;IACE,eAAgB;EAClB;;AAEA;IACE,qBAAqB;EAKvB;;AAHE;MACE,0BAA0B;IAC5B;;AAGF;IACE,kCAAkC;EACpC;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,mDAAgB;IAChB,eAAe;EACjB;;AAEA;IACE,mDAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,WAAW;EACb;;AAEA;IACE,mBAAmB;EACrB;;AAEA;IACE,iBAAiB;EACnB;;AAEA;IACE,mDAAgB;EAClB;;AAEA;IACE,mDAAW;IACX,mBAAmB;EACrB;;AAEA;IACE,wDAAuB;IACvB,yBAAyB;IACzB,cAAc;EAChB;;AAEA;IAEE,wDAAuB;IACvB,yBAAyB;IACzB,YAAY;EACd;;AAEA;IACE,wDAAuB;IACvB,uBAAuB;IACvB,YAAY;EACd;;AAEA;IAGE,wDAAkB;IAClB,uBAAuB;IACvB,YAAY;EACd;;AAEA;IAEE,wDAAuB;IACvB,uBAAuB;EACzB;;AAEA;IACE,kDAAY;EACd;;AAEA;IACE,iBAAiB;EACnB;;AAEA,6BAA6B;;AAC7B;IACE,wBAAwB;EAC1B;;AAGF,kDAAkD;AAEhD;IAEE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,6BAAqB;IAArB,qBAAqB;EACvB;AAEA;IACE,cAAc;IACd,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,8BAA8B;IAC9B,UAAU;IACV,gCAAgC;EAClC;AAEA;IACE,aAAa;EAaf;AAXE;MACE,WAAW;MACX,YAAY;MACZ,UAAU;IACZ;AAEA;MACE,aAAa;MACb,sCAAsC;MACtC,UAAU;IACZ","sourcesContent":["@value colors: 'styles/colors.css';\n@value gtBlue, gtBlueLight, gtBlueDark, gtGrayDark, gtGray, gtGrayLight, textLight, text, gtGreen from colors;\n@value gtBackground from colors;\n\n@lost gutter 20px;\n@lost flexbox flex;\n@lost cycle none;\n\n:global {\n  html {\n    box-sizing: border-box;\n  }\n\n  html,\n  body {\n    background-color: gtBackground;\n    font-size: 14px;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    text-rendering: optimizeLegibility;\n  }\n\n  body * {\n    &::-webkit-scrollbar {\n      background: gtGrayLight;\n      width: 10px;\n    }\n\n    &::-webkit-scrollbar-track {\n      -webkit-box-shadow: none;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(0, 0, 0, 0.4);\n      outline: none;\n    }\n  }\n\n  i {\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n\n  a {\n    box-shadow: 0 1px 0 rgba(55, 110, 161, 0.2);\n    color: gtBlue;\n    text-decoration: none;\n    transition: all 0.2s;\n\n    &:hover {\n      box-shadow: 0 1px 0 rgba(55, 110, 161, 1);\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  *:focus {\n    outline: none;\n  }\n\n  button {\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  .half {\n    lost-column: 1/2;\n\n    @media only screen and (max-width: 768px) {\n      lost-column: 1;\n    }\n  }\n\n  .third {\n    lost-column: 1/3;\n  }\n\n  .quarter {\n    lost-column: 1/4;\n  }\n\n  .checkbox {\n    label {\n      display: inline-block;\n      line-height: 30px;\n      margin: 0;\n    }\n\n    & > div > div {\n      float: left;\n    }\n\n    input {\n      height: 30px;\n      width: 30px;\n    }\n  }\n\n  .fileLabel {\n    color: gtGrayDark;\n    font-size: 12px;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n  }\n\n  .column {\n    lost-flex-container: column;\n  }\n\n  .row {\n    lost-flex-container: row;\n  }\n\n  .clearfix::after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n\n  .titleWrapper {\n    margin-bottom: 20px;\n    width: 100%;\n  }\n\n  .title {\n    flex: 1;\n    margin: 0;\n  }\n\n  .subtitle {\n    margin: 0;\n  }\n\n  .clear {\n    clear: both;\n  }\n\n  .content-container {\n    lost-center: 1440px 20px;\n    padding-bottom: 20px;\n    padding-top: 20px;\n  }\n\n  .section {\n    background: white;\n    border-radius: 3px;\n    margin-bottom: 20px;\n    padding: 20px;\n    width: 100%;\n  }\n\n  .sectionSmall {\n    background: white;\n    border-radius: 3px;\n    margin-bottom: 1px;\n    padding: 20px;\n    width: 100%;\n  }\n\n  .sectionLarge {\n    background: white;\n    border-radius: 3px;\n    margin-bottom: 40px;\n    padding: 20px;\n    width: 100%;\n  }\n\n  .sectionTitle {\n    background: white;\n    border-radius: 3px;\n    margin-bottom: 1px;\n    padding: 10px 20px;\n    width: 100%;\n  }\n\n  .sectionMinus {\n    margin-bottom: -19px;\n  }\n\n  .filterButton {\n    background: gtGray;\n    border: none;\n    border-radius: 3px;\n    box-shadow: none;\n    color: gtGreen;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 13px;\n    font-weight: 700;\n    height: 36px;\n    line-height: 36px;\n    margin-left: 20px;\n    padding: 0 1.5em;\n    text-decoration: none;\n    text-shadow: none;\n    transition: all 0.25s;\n    width: auto;\n\n    &:hover {\n      box-shadow: none;\n      opacity: 0.9;\n    }\n\n    &:active {\n      background: #e0e0e0;\n    }\n\n    &:first-child {\n      margin-left: 0;\n    }\n\n    &.active {\n      background: gtGreen;\n      color: white;\n    }\n  }\n\n  .oneThird {\n    lost-column: 1/3;\n  }\n\n  .twoThird {\n    lost-column: 2/3;\n  }\n\n  .capitalize {\n    display: inline-block;\n\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n\n  .mono {\n    font-family: MaisonMono, monospace;\n  }\n\n  .hide {\n    display: none;\n  }\n\n  .label {\n    color: textLight;\n    font-size: 12px;\n  }\n\n  .phoneLabel {\n    color: textLight;\n    display: inline-block;\n    font-size: 12px;\n    width: 60px;\n  }\n\n  .marginBottom {\n    margin-bottom: 20px;\n  }\n\n  .bold {\n    font-weight: bold;\n  }\n\n  .light {\n    color: textLight;\n  }\n\n  .normal {\n    color: text;\n    font-weight: normal;\n  }\n\n  .CalendarDay__default:hover {\n    background: gtGrayLight;\n    border: 1px solid #e4e7e7;\n    color: inherit;\n  }\n\n  .CalendarDay__selected_span:active,\n  .CalendarDay__selected_span:hover {\n    background: gtGrayLight;\n    border: 1px solid #e4e7e7;\n    color: black;\n  }\n\n  .CalendarDay__selected_span {\n    background: gtBlueLight;\n    border: 1px solid white;\n    color: black;\n  }\n\n  .CalendarDay__selected,\n  .CalendarDay__selected:active,\n  .CalendarDay__selected:hover {\n    background: gtBlue;\n    border: 1px solid white;\n    color: white;\n  }\n\n  .CalendarDay__hovered_span,\n  .CalendarDay__hovered_span:hover {\n    background: gtBlueLight;\n    border: 1px solid white;\n  }\n\n  .DateRangePickerInput_calendarIcon_svg {\n    fill: gtBlue;\n  }\n\n  .DateInput_input__small {\n    padding-bottom: 0;\n  }\n\n  /* react-collapse animation */\n  .ReactCollapse--collapse {\n    transition: height 500ms;\n  }\n}\n\n/* react-simple-dropdown library style overrides */\n:global {\n  .dropdown__trigger,\n  .dropdown__trigger:hover {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    box-shadow: none;\n    text-decoration: none;\n  }\n\n  .dropTriggerBackground {\n    display: block;\n    width: 0;\n    height: 0;\n    margin: auto;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    opacity: 0;\n    transition: opacity linear 250ms;\n  }\n\n  .dropdown--active {\n    display: flex;\n\n    .dropTriggerBackground {\n      width: 100%;\n      height: 100%;\n      opacity: 1;\n    }\n\n    .dropdown__content {\n      display: flex;\n      transform: translateX(0) translateY(0);\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `'styles/colors.css'`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtBackground": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBackground"]}`
};
export default ___CSS_LOADER_EXPORT___;
